<section class="portfolio">
  <div class="portfolio__inner row pad">
    <h1 class="portfolio__title">Portfolio</h1>
    <div class="search">
      <input
        class="search__input"
        type="text"
        placeholder="Search"
        [(ngModel)]="searchTerm"
        (input)="onSearchChange(searchTerm)"
      />
      <button
        type="button"
        class="search__filter"
        [class.search__filter--opened]="isFilterVisible"
        (click)="isFilterVisible = !isFilterVisible"
      >
        <img src="/filter-icon.svg" alt="Filter Icon" />
        <span>Filter Properties</span>
      </button>
    </div>

    <!-- FILTER -->
    <div class="filter" [class.filter--visible]="isFilterVisible">
      <div class="filter__header">
        <div class="filter__title">
          Filter Properties
          <button
            (click)="isFilterVisible = false"
            class="filter__title-close hide-medium"
          >
            <img src="/icon-close.svg" alt="Close Icon" />
          </button>
        </div>
        <div class="filter__buttons">
          <button
            type="button"
            class="filter__button filter__button--close btn"
            (click)="applyFilters()"
          >
            Apply Filters
          </button>
          <button
            type="button"
            class="filter__button filter__button--reset btn btn--secondary"
            (click)="clearFilters()"
          >
            Clear All
          </button>
        </div>
      </div>
      <div class="filter__content">
        <div class="filter__group">
          <div class="filter__group-title">Category</div>
          <div class="filter__options">
            @for (category of allCategories; track $index) {
              <label class="filter__option">
                <input
                  type="checkbox"
                  class="filter__option-checkbox"
                  [checked]="isCategorySelected(category)"
                  (change)="onCategoryChange(category, $event.target.checked)"
                />
                <span class="filter__option-text">{{ category }}</span>
              </label>
            }
          </div>
        </div>
        <div class="filter__group">
          <div class="filter__group-title">Region</div>
          <div class="filter__options">
            @for (region of allRegions; track $index) {
              <label class="filter__option">
                <input
                  type="checkbox"
                  class="filter__option-checkbox"
                  [checked]="isRegionSelected(region)"
                  (change)="onRegionChange(region, $event.target.checked)"
                />
                <span class="filter__option-text">{{ region }}</span>
              </label>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- CHIPS -->
    @if (selectedCategories.length > 0 || selectedRegions.length > 0) {
      <div class="chips">
        <div class="chips__list">
          @for (category of selectedCategories; track $index) {
            <div class="chips__item">
              <span class="chips__text">{{ category }}</span>
              <button
                type="button"
                class="chips__remove"
                (click)="removeCategoryFilter(category)"
              >
                <img src="/icon-cross.svg" alt="Cross Icon" />
              </button>
            </div>
          }
          @for (region of selectedRegions; track $index) {
            <div class="chips__item">
              <span class="chips__text">{{ region }}</span>
              <button
                type="button"
                class="chips__remove"
                (click)="removeRegionFilter(region)"
              >
                <img src="/icon-cross.svg" alt="Cross Icon" />
              </button>
            </div>
          }
        </div>
        <div class="chips__clear">
          <img
            src="/icon-refresh.svg"
            alt="Clear Filters"
            (click)="clearFilters()"
          />
        </div>
      </div>
    }

    <!-- ITEMS -->
    <div class="portfolio__events" id="events">
      @for (event of filteredEvents; track $index) {
        @let website = (event.website || '').trim();
        <a class="event" [attr.href]="website || null" target="_blank">
          <div class="event__overlay">
            <div class="event__overlay-inner">
              <div class="event__overlay-info">
                <div class="event__category">
                  {{ event.category | uppercase }}
                </div>
                <h2 class="event__title">{{ event.title }}</h2>
              </div>
              @if (website) {
                <div class="event__overlay-offset">
                  <div class="event__visit">
                    <span>Visit website</span>
                    <img src="/portfolio-arrow.svg" alt="Visit website" />
                  </div>
                </div>
              }
            </div>
          </div>
          <img
            src="{{ event.imageUrl }}"
            alt="{{ event.title }} Image"
            class="event__image"
          />
        </a>
      }
    </div>

    <!-- PAGINATION -->
    <div class="pagination">
      <button
        class="pagination__button pagination__button--previous"
        (click)="goToPreviousPage()"
        [disabled]="currentPage === 1"
      >
        <img src="/arrow.svg" alt="Previous Page" />
      </button>
      @for (item of [].constructor(totalPages); track $index) {
        <button
          class="pagination__button"
          (click)="goToPage($index + 1)"
          [class.pagination__button--active]="currentPage === $index + 1"
        >
          {{ $index + 1 }}
        </button>
      }
      <button
        class="pagination__button pagination__button--next"
        (click)="goToNextPage()"
        [disabled]="currentPage === totalPages || totalPages === 0"
      >
        <img src="/arrow.svg" alt="Next Page" />
      </button>
    </div>
  </div>
</section>

<app-contact-section></app-contact-section>
